import { useState, useEffect } from 'react';
import { MapPin, Navigation, ExternalLink } from 'lucide-react';

const RouteMap = ({ origin, destination }) => {
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    if (origin && destination && origin.length > 3 && destination.length > 3) {
      const timer = setTimeout(() => setShowMap(true), 600);
      return () => clearTimeout(timer);
    } else {
      setShowMap(false);
    }
  }, [origin, destination]);

  if (!showMap) return null;

  const mapSrc = `https://www.google.com/maps?q=&saddr=${encodeURIComponent(origin)}&daddr=${encodeURIComponent(destination)}&dirflg=d&output=embed`;
  const mapLink = `https://www.google.com/maps/dir/${encodeURIComponent(origin)}/${encodeURIComponent(destination)}`;

  return (
    <div className="mt-6" data-testid="route-map-container">
      <iframe
        title="Route Map"
        src={mapSrc}
        className="w-full border border-[#D4AF37]/30"
        style={{ height: '300px', border: 'none' }}
        allowFullScreen
        loading="lazy"
        data-testid="route-map"
      />
      <div className="flex justify-end mt-2">
        <a
          href={mapLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-xs text-[#D4AF37] hover:text-[#D4AF37]/80 transition-colors"
          data-testid="open-maps-link"
        >
          <ExternalLink className="w-3 h-3" />
          Google Maps
        </a>
      </div>
    </div>
  );
};

export default RouteMap;
